import GetCurrentLang from "./GetCurrentLang";

const formatDate = (lang : string, d : any, short: boolean) => {
  const yy = new Intl.DateTimeFormat(lang, { year: 'numeric' }).format(new Date(d))
  const mm = new Intl.DateTimeFormat(lang, { month: (short) ? 'short' : 'long' }).format(new Date(d))
  const dd = new Intl.DateTimeFormat(lang, { day: '2-digit' }).format(new Date(d))
  return `${dd} ${mm} ${yy}`
}

const FormatPeriod = (start : string, end : string, short: boolean) : string => {
  let output : string = ''
  let lang : string = GetCurrentLang()
  let parseEnd : string = formatDate(lang, end, short)
  
  if(isNaN(Date.parse(start)) === false) {
    let parseStart : string = formatDate(lang, start, short)
    output += `${GetCurrentLang() === 'en' ? ((short) ? 'Period' : 'Promotion Period') : ((short) ? 'Periode' : 'Periode Promosi')} ${parseStart} - ${parseEnd}`
  }else {
    output += `${GetCurrentLang() === 'en' ? 'Until' : 'Berlaku hingga'} ${parseEnd}`
  }

  return output
}

export default FormatPeriod